import styled from "styled-components";
import Colors from "../../../../themes/Colors";

const CampaignsManagerHolder = styled.div`
  width: 100%;

  .ant-btn-primary,
  .ant-btn-primary:active {
    background-color: ${Colors.primary};
    border-color: ${Colors.primary};
  }
  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    background-color: ${Colors.backgroundPrimary};
    border-color: ${Colors.backgroundPrimary};
  }
  .ant-tabs-nav .ant-tabs-tab-active {
    color: ${Colors.primaryAccent};
  }
  .ant-tabs-ink-bar {
    background-color: ${Colors.primary};
  }

  .campaignsManager__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  .campaignsManager__title {
    font-size: 24px;
    font-weight: 600;
    color: ${Colors.coal};
    margin: 0;
  }

  .campaignsManager__toolbar {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin: 12px 0 20px;
  }

  .campaignsManager__toolbar-search {
    max-width: 320px;
    flex: 1 1 220px;
  }

  .campaignsManager__toolbar-right {
    margin-left: auto;
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .campaignsManager__filters {
    display: flex;
    align-items: flex-end;
    gap: 16px;
    flex-wrap: wrap;
    background: ${Colors.snow};
    border: 1px solid ${Colors.border};
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
    padding: 16px;
    margin-bottom: 20px;
  }

  .campaignsManager__filters-field {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .campaignsManager__filters-field label {
    font-size: 12px;
    color: ${Colors.grayMedium};
  }

  .campaignsManager__filters-client {
    flex: 1 1 280px;
    min-width: 220px;
  }

  .campaignsManager__pagination {
    margin-top: 24px;
    text-align: center;
  }

  .campaignsManager__empty {
    padding: 48px;
    text-align: center;
    color: ${Colors.grayMedium};
    border: 1px dashed ${Colors.grayMedium};
    border-radius: 8px;
  }
`;

export default CampaignsManagerHolder;
